import React from "react";
import { Button } from "@/components/ui/button";
import { CheckSquare, Eye, RefreshCw, Trash2, Undo2, X, ZoomIn } from "lucide-react";

export function ReceiptsBulkActionBar({
  selectedCount,
  bulkBusy,
  onMarkReviewed,
  onMarkUnreviewed,
  onReanalyze,
  onUnbook,
  onDelete,
  onClear,
  onCompare,
}) {
  if (selectedCount === 0) return null;
  return (
    <div
      className="mb-3 flex flex-wrap items-center gap-2 rounded-lg border border-violet-200 bg-violet-50 px-3 py-2"
      data-testid="receipts-bulk-action-bar"
    >
      <span className="text-xs font-medium text-violet-900">
        {selectedCount} Beleg(e) ausgewählt
      </span>
      <div className="flex-1" />
      {onCompare && (
        <Button
          variant="outline"
          size="sm"
          onClick={onCompare}
          disabled={bulkBusy || selectedCount < 2 || selectedCount > 3}
          title={selectedCount < 2 ? "Mindestens 2 Belege anhaken" : selectedCount > 3 ? "Höchstens 3 Belege vergleichen" : "Ausgewählte Belege gross nebeneinander anzeigen"}
          data-testid="receipts-bulk-compare"
        >
          <ZoomIn className="h-3.5 w-3.5 mr-1" /> Lupe: vergleichen
        </Button>
      )}
      <Button
        variant="outline"
        size="sm"
        onClick={onMarkReviewed}
        disabled={bulkBusy}
        data-testid="receipts-bulk-mark-reviewed"
      >
        <CheckSquare className="h-3.5 w-3.5 mr-1" />
        Als geprüft markieren
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onMarkUnreviewed}
        disabled={bulkBusy}
        data-testid="receipts-bulk-mark-unreviewed"
      >
        <Eye className="h-3.5 w-3.5 mr-1" />
        Ungeprüft
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onReanalyze}
        disabled={bulkBusy}
        className="text-indigo-700 border-indigo-200 hover:bg-indigo-50"
        data-testid="receipts-bulk-reanalyze"
      >
        <RefreshCw className={`h-3.5 w-3.5 mr-1 ${bulkBusy ? "animate-spin" : ""}`} />
        Neu analysieren
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onUnbook}
        disabled={bulkBusy}
        className="text-amber-700 border-amber-200 hover:bg-amber-50"
        data-testid="receipts-bulk-unbook"
      >
        <Undo2 className="h-3.5 w-3.5 mr-1" />
        Rückverbuchen
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onDelete}
        disabled={bulkBusy}
        className="text-rose-700 border-rose-200 hover:bg-rose-50"
        data-testid="receipts-bulk-delete"
        title="Bestätigung aufheben – die Belege gehen zurück in den Posteingang (verbuchte werden übersprungen)"
      >
        <Trash2 className="h-3.5 w-3.5 mr-1" />
        Löschen → Posteingang
      </Button>
      <Button variant="ghost" size="sm" onClick={onClear} data-testid="receipts-bulk-clear">
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
